/**
 * The booth event the till is currently selling under, remembered per device.
 *
 * Only the id is persisted, never a copy of the event: the fetched list stays
 * the source of truth, so an event renamed or archived on another device cannot
 * leave a stale label here, and one deleted elsewhere simply resolves to "no
 * event" instead of a dangling object.
 */
export const ACTIVE_EVENT_STORAGE_KEY = 'cashier.activeEvent';

export function readStoredEventId(): number | null {
  try {
    const raw = localStorage.getItem(ACTIVE_EVENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = Number(raw);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
  } catch {
    return null;
  }
}

export function storeEventId(eventId: number | null): void {
  try {
    if (eventId === null) {
      localStorage.removeItem(ACTIVE_EVENT_STORAGE_KEY);
      return;
    }
    localStorage.setItem(ACTIVE_EVENT_STORAGE_KEY, String(eventId));
  } catch {
    // Storage unavailable (private mode, quota). Selling still works; the choice
    // just will not survive a reload.
  }
}
